<template>
  <div>
    <div style="padding: 40px">
      <hi-media-caption></hi-media-caption>
      <hi-media-caption :active="true"></hi-media-caption>
      <hi-media-caption :date="false"></hi-media-caption>
    </div>
  </div>
</template>

<script>
import hiMediaCaption from "../../../components/calender/caption/Index.vue";
export default {
  name: "MediaCaptionPage",
  components: { hiMediaCaption },
};
</script>

<style lang="less" scoped></style>
